import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { GoogleEmailIntegrationResponse } from 'src/queries/organizations/emailIntegrations/emailIntegrations.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

const googleEmailIntegrationUrl = (orgId: string) =>
  `/organizations/${orgId}/email-integrations/google`

export const getGoogleEmailIntegration = async (
  orgId: string,
): Promise<GoogleEmailIntegrationResponse> =>
  getResponseData(
    axios.get<GoogleEmailIntegrationResponse>(
      googleEmailIntegrationUrl(orgId),
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const connectGoogleEmailIntegration = async (
  orgId: string,
): Promise<GoogleEmailIntegrationResponse> =>
  getResponseData(
    axios.put<GoogleEmailIntegrationResponse>(
      googleEmailIntegrationUrl(orgId),
      undefined,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const disconnectGoogleEmailIntegration = async (
  orgId: string,
): Promise<GoogleEmailIntegrationResponse> =>
  getResponseData(
    axios.delete<GoogleEmailIntegrationResponse>(
      googleEmailIntegrationUrl(orgId),
      getRequestConfig(RequestConfig.Default),
    ),
  )
